import { ApprovalMethodTypeDTO as ApprovalMethodType } from 'anchor-ts-infra/src/dto/approval-method/dto';
import { FailureCodeEnum as InvoicePaymentFailureCode } from 'anchor-ts-infra/src/dto/invoice/dto';
export { ApprovalMethodType, InvoicePaymentFailureCode };
export var InvoiceDisplayStatus = /*#__PURE__*/ function(InvoiceDisplayStatus) {
    InvoiceDisplayStatus["Issued"] = "issued";
    InvoiceDisplayStatus["PaymentInitiated"] = "paymentInitiated";
    InvoiceDisplayStatus["Paid"] = "paid";
    InvoiceDisplayStatus["Overdue"] = "overdue";
    InvoiceDisplayStatus["Voided"] = "voided";
    InvoiceDisplayStatus["Refunded"] = "refunded";
    InvoiceDisplayStatus["PartiallyRefunded"] = "partiallyRefunded";
    InvoiceDisplayStatus["RefundFailed"] = "refundFailed";
    InvoiceDisplayStatus["PaymentDisputed"] = "disputed";
    InvoiceDisplayStatus["DisputeWon"] = "disputeWon";
    return InvoiceDisplayStatus;
}({});
export var InvoiceDisplayStatusV2 = /*#__PURE__*/ function(InvoiceDisplayStatusV2) {
    InvoiceDisplayStatusV2["Issued"] = "issued";
    InvoiceDisplayStatusV2["Pending"] = "pending";
    InvoiceDisplayStatusV2["Overdue"] = "overdue";
    InvoiceDisplayStatusV2["Processing"] = "processing";
    InvoiceDisplayStatusV2["Paid"] = "paid";
    InvoiceDisplayStatusV2["RefundFailed"] = "refundFailed";
    InvoiceDisplayStatusV2["Refunded"] = "refunded";
    InvoiceDisplayStatusV2["PartiallyRefunded"] = "partiallyRefunded";
    InvoiceDisplayStatusV2["Voided"] = "voided";
    InvoiceDisplayStatusV2["Disputed"] = "disputed";
    InvoiceDisplayStatusV2["DisputeWon"] = "disputeWon";
    InvoiceDisplayStatusV2["LateReturn"] = "lateReturn";
    return InvoiceDisplayStatusV2;
}({});
export var InvoiceDashboardCard = /*#__PURE__*/ function(InvoiceDashboardCard) {
    InvoiceDashboardCard["CollectionRate"] = "collection-rate";
    InvoiceDashboardCard["AnchorVsExternal"] = "anchor-vs-external";
    InvoiceDashboardCard["AvgDaysToPay"] = "avg-days-to-pay";
    InvoiceDashboardCard["Outstanding"] = "outstanding";
    InvoiceDashboardCard["AgingBreakdown"] = "aging-breakdown";
    InvoiceDashboardCard["AvgInvoice"] = "avg-invoice";
    InvoiceDashboardCard["Paid"] = "paid";
    InvoiceDashboardCard["Pending"] = "pending";
    InvoiceDashboardCard["Overdue"] = "overdue";
    InvoiceDashboardCard["Issued"] = "issued";
    InvoiceDashboardCard["Processing"] = "processing";
    InvoiceDashboardCard["Refunded"] = "refunded";
    InvoiceDashboardCard["Voided"] = "voided";
    InvoiceDashboardCard["Disputed"] = "disputed";
    InvoiceDashboardCard["MissingPaymentMethod"] = "missing-payment-method";
    InvoiceDashboardCard["ClientApprovalRequired"] = "client-approval-required";
    InvoiceDashboardCard["PaymentStopped"] = "payment-stopped";
    InvoiceDashboardCard["PaymentFailed"] = "payment-failed";
    InvoiceDashboardCard["PaymentValidationRequired"] = "payment-validation-required";
    InvoiceDashboardCard["PaymentMethodUnverified"] = "payment-method-unverified";
    return InvoiceDashboardCard;
}({});
export const DEFAULT_INVOICE_DASHBOARD_CARDS = [
    "collection-rate",
    "anchor-vs-external",
    "avg-days-to-pay",
    "outstanding",
    "aging-breakdown"
];
export function isInvoiceDashboardCard(value) {
    return Object.values(InvoiceDashboardCard).includes(value);
}
export function dashboardStatusBucket(status) {
    switch(status){
        case "paid":
        case "disputeWon":
            return 'paid';
        case "pending":
            return 'pending';
        case "overdue":
        case "lateReturn":
            return 'overdue';
        case "issued":
            return 'issued';
        case "processing":
            return 'processing';
        case "refunded":
        case "partiallyRefunded":
            return 'refunded';
        case "disputed":
            return 'disputed';
        case "refundFailed":
            // RefundFailed intentionally excluded from every dashboard bucket — Widget Reference spec.
            return undefined;
        case "voided":
            return 'voided';
    }
}
export function isOpenInvoiceStatus(status) {
    switch(status){
        case "issued":
        case "pending":
        case "overdue":
        case "processing":
        case "lateReturn":
            return true;
        case "paid":
        case "refunded":
        case "partiallyRefunded":
        case "refundFailed":
        case "voided":
        case "disputed":
        case "disputeWon":
            return false;
    }
}
export var PaymentDetailType = /*#__PURE__*/ function(PaymentDetailType) {
    PaymentDetailType["MissingPaymentMethod"] = "missingPaymentMethod";
    PaymentDetailType["PaymentMethodNotVerified"] = "paymentMethodNotVerified";
    PaymentDetailType["ClientApprovalRequired"] = "clientApprovalRequired";
    PaymentDetailType["PaymentStopped"] = "paymentStopped";
    PaymentDetailType["PaymentValidationRequired"] = "paymentValidationRequired";
    PaymentDetailType["PaymentScheduled"] = "paymentScheduled";
    PaymentDetailType["PaymentAwaitingInitiation"] = "paymentAwaitingInitiation";
    PaymentDetailType["PaymentInitiated"] = "paymentInitiated";
    PaymentDetailType["PaymentCollected"] = "paymentCollected";
    PaymentDetailType["RefundRequested"] = "refundRequested";
    PaymentDetailType["Refunded"] = "refunded";
    PaymentDetailType["PaidExternally"] = "paidExternally";
    PaymentDetailType["PaymentFailed"] = "paymentFailed";
    PaymentDetailType["PaidOnDate"] = "paidOnDate";
    PaymentDetailType["Deposited"] = "deposited";
    PaymentDetailType["Voided"] = "voided";
    PaymentDetailType["Disputed"] = "disputed";
    PaymentDetailType["RefundFailed"] = "refundFailed";
    PaymentDetailType["PaymentLateReturned"] = "paymentLateReturned";
    return PaymentDetailType;
}({});
export const ISSUES_PREVENTING_PAYMENT = [
    "missingPaymentMethod",
    "clientApprovalRequired",
    "paymentStopped",
    "paymentFailed",
    "paymentValidationRequired",
    "paymentMethodNotVerified"
];
export var InvoicePaymentMethodStatus = /*#__PURE__*/ function(InvoicePaymentMethodStatus) {
    InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
    InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
    InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
    return InvoicePaymentMethodStatus;
}({});
export var InvoiceIntegrationStatusEnum = /*#__PURE__*/ function(InvoiceIntegrationStatusEnum) {
    InvoiceIntegrationStatusEnum["PendingSync"] = "pendingSync";
    InvoiceIntegrationStatusEnum["InvoiceSyncFailed"] = "invoiceSyncFailed";
    InvoiceIntegrationStatusEnum["PaymentSyncFailed"] = "paymentSyncFailed";
    InvoiceIntegrationStatusEnum["RefundSyncFailed"] = "refundSyncFailed";
    InvoiceIntegrationStatusEnum["InvoiceRecorded"] = "invoiceRecorded";
    InvoiceIntegrationStatusEnum["VoidedRecorded"] = "voidedRecorded";
    InvoiceIntegrationStatusEnum["RefundRecorded"] = "refundRecorded";
    InvoiceIntegrationStatusEnum["PaymentRecorded"] = "paymentRecorded";
    return InvoiceIntegrationStatusEnum;
}({});
export var InvoicePaymentDisplayStatusType = /*#__PURE__*/ function(InvoicePaymentDisplayStatusType) {
    InvoicePaymentDisplayStatusType["PaymentMethodNotSet"] = "paymentMethodNotSet";
    InvoicePaymentDisplayStatusType["PaymentMethodUnverified"] = "paymentMethodUnverified";
    InvoicePaymentDisplayStatusType["PaymentFailed"] = "paymentFailed";
    InvoicePaymentDisplayStatusType["Paid"] = "paid";
    InvoicePaymentDisplayStatusType["PaidExternally"] = "paidExternally";
    InvoicePaymentDisplayStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
    InvoicePaymentDisplayStatusType["RequiresPaymentValidation"] = "requiresPaymentValidation";
    InvoicePaymentDisplayStatusType["Processing"] = "processing";
    InvoicePaymentDisplayStatusType["Collected"] = "collected";
    InvoicePaymentDisplayStatusType["Refunded"] = "refunded";
    InvoicePaymentDisplayStatusType["RefundFailed"] = "refundFailed";
    InvoicePaymentDisplayStatusType["RefundRequested"] = "refundRequested";
    InvoicePaymentDisplayStatusType["Pending"] = "pending";
    InvoicePaymentDisplayStatusType["StoppedPayment"] = "stoppedPayment";
    InvoicePaymentDisplayStatusType["Disputed"] = "disputed";
    InvoicePaymentDisplayStatusType["DisputeWon"] = "disputeWon";
    InvoicePaymentDisplayStatusType["LateReturned"] = "lateReturned";
    InvoicePaymentDisplayStatusType["None"] = "none";
    return InvoicePaymentDisplayStatusType;
}({});
export var AccountingSyncStatusFilter = /*#__PURE__*/ function(AccountingSyncStatusFilter) {
    AccountingSyncStatusFilter["Synced"] = "sync";
    AccountingSyncStatusFilter["Unsynced"] = "unsync";
    return AccountingSyncStatusFilter;
}({});
// Mirrors go/servers/invoices/status/status.go InvoiceStatusType
export var InvoiceApiStatusType = /*#__PURE__*/ function(InvoiceApiStatusType) {
    InvoiceApiStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
    InvoiceApiStatusType["PaymentActionRequired"] = "paymentActionRequired";
    InvoiceApiStatusType["PaymentFailed"] = "paymentFailed";
    InvoiceApiStatusType["Pending"] = "pending";
    InvoiceApiStatusType["ProcessingCharge"] = "processingCharge";
    InvoiceApiStatusType["PaymentConfirmed"] = "paymentConfirmed";
    InvoiceApiStatusType["Paid"] = "paid";
    InvoiceApiStatusType["PaidExternally"] = "paidExternally";
    InvoiceApiStatusType["Voided"] = "voided";
    InvoiceApiStatusType["Refunded"] = "refunded";
    InvoiceApiStatusType["RefundFailed"] = "refundFailed";
    InvoiceApiStatusType["PaymentStopped"] = "paymentStopped";
    InvoiceApiStatusType["PaymentDisputed"] = "paymentDisputed";
    InvoiceApiStatusType["PaymentDisputeWon"] = "paymentDisputeWon";
    InvoiceApiStatusType["PartiallyRefunded"] = "partiallyRefunded";
    InvoiceApiStatusType["PaymentLateReturned"] = "paymentLateReturned";
    return InvoiceApiStatusType;
}({});
export var InvoiceSortingColumn = /*#__PURE__*/ function(InvoiceSortingColumn) {
    InvoiceSortingColumn["Number"] = "number";
    InvoiceSortingColumn["CompanyName"] = "companyName";
    InvoiceSortingColumn["Status"] = "status";
    InvoiceSortingColumn["DisplayStatusV2"] = "displayStatusV2";
    InvoiceSortingColumn["PaymentStatus"] = "paymentStatus";
    InvoiceSortingColumn["IssuedOn"] = "issuedOn";
    InvoiceSortingColumn["DueDate"] = "dueDate";
    InvoiceSortingColumn["TotalAmount"] = "totalAmount";
    return InvoiceSortingColumn;
}({});
export const MAX_PAYMENT_ATTEMPTS = 10;
